import React from 'react';

import {
  Card,
  CardTitle,
  CardBody,
  CardFooter,
  Content,
  ContentVariants,
  Label,
  LabelColor,
  Divider,
  Button,
  Flex,
  FlexItem
} from '@patternfly/react-core';
import { Link } from "react-router-dom";
import {
  normalizeWordPressUrl
} from "shared/utils/wordpressUrl";

const NewsCard = ({ news }) => {

  const publishDate = news.date
    ? new Date(news.date).toLocaleDateString('pl-PL')
    : '';
  const imageUrl = normalizeWordPressUrl(
    news.image
  );
  return (
    <Card
      isGlass
      isFullHeight
    >
      {imageUrl && (
        <Link
          to={`/news/${news.id}`}
          style={{
            display: "block",
            overflow: "hidden"
        }}
>
            <img
                src={imageUrl}
                alt={news.title}
                style={{
                width: '100%',
                height: '220px',
                objectFit: 'cover',
                marginBottom: '1rem',
                transition: 'transform .2s ease'
                }}
                onMouseOver={e => {
                    e.currentTarget.style.transform = 'scale(1.01)';
                }}
                onMouseOut={e => {
                    e.currentTarget.style.transform = 'scale(1)';
                }}
            />
            </Link>
      )}

      <CardTitle>
        <Flex
          justifyContent={{
            default: 'justifyContentSpaceBetween'
          }}
          alignItems={{
            default: 'alignItemsCenter'
          }}
        >
          <FlexItem>
            <Label
              variant="outline"
              color={LabelColor.blue}
            >
              {news.category}
            </Label>
          </FlexItem>

          <FlexItem>
            <Content component={ContentVariants.small}>
              {publishDate}
            </Content>
          </FlexItem>
        </Flex>
      </CardTitle>

      <CardBody>
        <Content component={ContentVariants.h3}>
          {news.title}
        </Content>

        <Divider />

        <br />

        <Content component={ContentVariants.small}>
          {news.excerpt}
        </Content>
      </CardBody>

      <CardFooter>
        {/* <Button
          component="a"
          href={news.link}
          target="_blank"
          rel="noopener noreferrer"
          variant="link"
          isInline
        >
          Czytaj więcej →
        </Button> */}
        <Button
          component={Link}
          to={`/news/${news.id}`}
          variant="link"
          isInline
        >
          Czytaj więcej →
        </Button>
      </CardFooter>
    </Card>
  );
};

export default NewsCard;